import {Typography} from '@material-ui/core';
import React, {useContext, useEffect, useState} from 'react';
import FileUploader from '../../../../shared/customFileUploader/fileUploader.jsx';
import {midiaInitialState} from './midiaInitialState';
import {useSnackbar} from 'notistack';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import GetAppIcon from '@material-ui/icons/GetApp';
import {Context} from '../../../../shared/context/AppContext';
import {getAudiosReuniao, getFotosReuniao, getVideosReuniao} from '../../../../../services/reuniao/ReuniaoService';
import {download as downloadDocumento} from '../../../../../services/documento/DocumentoService';
import UseStyle from "../../../useStyles";
import {mimeTypes} from '../../../../../utils/mimeTypes';

const Fotos = (props) => {

  const classes = UseStyle();
  const { enqueueSnackbar } = useSnackbar();
  const { roles } = useContext(Context);

  const { id } = props;

  const [selectedOption, setSelectedOption] = useState(0);

  const [midiaObj, setMidiaObj] = useState(midiaInitialState);

  const initFotos = () => {
    getFotosReuniao(id).then((data) => {
      const aux = { ...midiaObj };
      const pictures = data.data;
      aux[0].files = [...pictures];
      setMidiaObj({ ...aux });
    });
  }

  const initVideos = () => {
    getVideosReuniao(id).then((data) => {
      const aux = { ...midiaObj };
      const pictures = data.data;
      aux[1].files = [...pictures];
      setMidiaObj({ ...aux });
    });
  }

  const initAudios = () => {
    getAudiosReuniao(id).then((data) => {
      const aux = { ...midiaObj };
      const pictures = data.data;
      aux[2].files = [...pictures];
      setMidiaObj({ ...aux });
    });
  }

  const handleEvent = (event) => {
    const files = event.target.files;
    return files;
  }

  const handleFilter = (file) => {
    let extension = file.name.split('.');
    extension = extension[extension.length - 1];
    if (!midiaObj[selectedOption].fileExtension.some(ext => ext.toUpperCase() === extension.toUpperCase())) {
      enqueueSnackbar(`Arquivo com formato inválido.`, { variant: 'error' });
      return false;
    }
    if (file.size > midiaObj[selectedOption].maxSizeByte) {
      enqueueSnackbar(`Arquivo com tamanho inválido.`, { variant: 'error' });
      return false;
    }
    return true;
  }

  const handleSaveFiles = (files) => {
    let requests = [];
    for (let file of files) {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('idReuniao', id);
      formData.append('nome', file.name);
      formData.append('tipo', 1); // Será reformulado;
      requests.push(midiaObj[selectedOption].upload(formData));
    }
    if (requests.length) {
      Promise.all([...requests]).then((success) => {
        success.map((suc) => {
          if (!suc) {
            enqueueSnackbar(`Erro ao realizar upload de arquivo`, { variant: 'error' });
          } else {
            enqueueSnackbar('Novo documento adicionado com Sucesso! '+ suc.data, { variant: 'success' })
          }
        })
      }).catch((error) => {
        console.log(error);
      }).finally(async () => {
        try {
          const updateData = await midiaObj[selectedOption].getData(id);
          const dataArray = [...updateData.data];
          updateAllMidia(dataArray);
        } catch (err) {
          console.log(err);
        } finally {
          // espaço para setLoading false
        }
      });
    }
  }

  const handleDeleteFile = async (fileId) => {
    try {
      await midiaObj[selectedOption].delete(fileId);
      const updateData = await midiaObj[selectedOption].getData(id);
      const dataArray = [...updateData.data];
      updateAllMidia(dataArray);
    } catch (error) {
      console.log(error);
    } finally {
      // espaço para setLoading false
    }
  }

  const handleUpload = (event) => {
    let files;
    if (event.target) {
      files = [...handleEvent(event)];
    } else {
      files = [...event];
    };
    files = files.filter(handleFilter);
    if (files.length) {
      handleSaveFiles(files);
    }
  }

  const nativeDownload = (blob, fileName) => {
    const link = document.createElement('a');
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', fileName);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  const handleDownload = (file) => {
    if (!(file.formato.toLowerCase() in mimeTypes)) {
      enqueueSnackbar(`Arquivo com formato inválido.`, { variant: 'error' });
      return;
    }
    downloadDocumento(file.id).then((data) => {
      const type = { type: mimeTypes[file.formato.toLowerCase()] };
      const blob = new Blob([data.data], type);
      nativeDownload(blob, file.nome)
    }).catch((error) => {
      console.log(error);
    });
  }

  const getSize = (tamanho) => {
    if (tamanho >= (1024 * 1024 * 1024)) {
      return `${parseInt(tamanho / (1024 * 1024 * 1024))}gb`;
    }
    if (tamanho >= (1024 * 1024)) {
      return `${parseInt(tamanho / (1024 * 1024))}mb`;
    }
    if (tamanho >= 1024) {
      return `${parseInt(tamanho / 1024)}kb`;
    }
    return `${tamanho}bytes`;
  }

  const eraseFiles = () => {
    const aux = { ...midiaObj };
    aux[selectedOption].files = [];
    setMidiaObj({ ...aux });
  }

  const updateAllMidia = (data) => {
    eraseFiles(id);
    const aux = { ...midiaObj };
    aux[selectedOption].files = [...data];
    setMidiaObj({ ...aux });
  }

  useEffect(() => {
    initFotos();
    // initVideos();
    initAudios();
  }, []);

  return (
    <>
      <div className={classes.optionsContainer}>
        <Typography className={`${classes.midiaOptions} ${selectedOption === 0 && 'active'}`} onClick={() => setSelectedOption(0)}>{midiaObj[0].label}</Typography>
        {/*<Typography className={`${classes.midiaOptions} ${selectedOption === 1 && 'active'}`} onClick={() => setSelectedOption(1)}>{midiaObj[1].label}</Typography>*/}
        <Typography className={`${classes.midiaOptions} ${selectedOption === 2 && 'active'}`} onClick={() => setSelectedOption(2)}>{midiaObj[2].label}</Typography>
      </div>
      {roles.some(role => role.includes('EQUIPE_TECNICA')) && <div>
        <FileUploader
          text={`Máximo de ${midiaObj[selectedOption].maxSize}. Somente ${midiaObj[selectedOption].text()}.`}
          handleUpload={handleUpload}
        />
      </div>}
      {!!midiaObj[selectedOption].files.length && <div>
        <Typography className={classes.midiaSectionTitle} component="h6">{midiaObj[selectedOption].label}</Typography>
        <div className={classes.midiaTableHeader}>
          <Typography className={classes.midiaTableHeaderRows}>Nome</Typography>
          <Typography className={classes.midiaTableHeaderRows}>Tamanho</Typography>
        </div>
        {midiaObj[selectedOption].files.map((item) => (
          <div className={classes.midiaTableItens} key={item.id}>
            <Typography className={classes.midiaTableName}>{item.nome}</Typography>
            <Typography className={classes.midiaTableSize}>{getSize(item.tamanho)}</Typography>
            <div className={classes.midiaTableIcons}>
              <button onClick={() => handleDownload(item)} className={classes.downloadMidia}><GetAppIcon /></button>
              {roles.some(role => role.includes('EQUIPE_TECNICA')) && <DeleteForeverIcon
                onClick={() => handleDeleteFile(item.id)} />}
            </div>
          </div>
        ))}
      </div>}
    </>
  );
}

export default Fotos;
